import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from './Layout';

const TermsPage = () => {
  return (
    <Layout breadcrumbItems={[
      { label: 'Home', href: '/' },
      { label: 'Terms of Service', href: '/terms' }
    ]}>
      <Helmet defer={false}>
        <title>Terms of Service - Free Google SERP Checker</title>
        <meta name="description" content="Terms of Service for our free Google SERP checker tool. Read our terms and conditions of use." />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Terms of Service - Free Google SERP Checker" />
        <meta property="og:description" content="Terms of Service for our free Google SERP checker tool. Read our terms and conditions of use." />
        <meta property="og:url" content="https://freeserpchecker.org/terms" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Terms of Service - Free Google SERP Checker" />
        <meta name="twitter:description" content="Terms of Service for our free Google SERP checker tool. Read our terms and conditions of use." />
      </Helmet>
      
      <div className="bg-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
            
            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="mb-4">
                  By accessing and using our free Google SERP checker tool, you accept and agree to be bound by 
                  the terms and provision of this agreement.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Use License</h2>
                <p className="mb-4">
                  Permission is granted to temporarily use our SERP checker tool for personal, 
                  non-commercial transitory viewing only.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Disclaimer</h2>
                <p className="mb-4">
                  The materials on our website are provided on an 'as is' basis. We make no warranties, 
                  expressed or implied, and hereby disclaim and negate all other warranties including 
                  without limitation, implied warranties or conditions of merchantability, fitness for 
                  a particular purpose, or non-infringement of intellectual property or other violation of rights.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Limitations</h2>
                <p className="mb-4">
                  In no event shall we or our suppliers be liable for any damages (including, without limitation, 
                  damages for loss of data or profit, or due to business interruption) arising out of the use 
                  or inability to use the materials on our website.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Accuracy of Materials</h2>
                <p className="mb-4">
                  The materials appearing on our website could include technical, typographical, or photographic errors. 
                  We do not warrant that any of the materials on our website are accurate, complete or current.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Links</h2>
                <p className="mb-4">
                  We have not reviewed all of the sites linked to our website and are not responsible for 
                  the contents of any such linked site. The inclusion of any link does not imply endorsement 
                  by us of the site.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Modifications</h2>
                <p className="mb-4">
                  We may revise these terms of service for our website at any time without notice. 
                  By using this website you are agreeing to be bound by the then current version 
                  of these Terms of Service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Governing Law</h2>
                <p className="mb-4">
                  These terms and conditions are governed by and construed in accordance with the laws 
                  and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Information</h2>
                <p className="mb-4">
                  If you have any questions about these Terms of Service, 
                  please contact us at terms@freeserpchecker.org
                </p>
              </section>

              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Last updated: January 2025
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;
